import { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import DashboardLayout from '../../../layouts/Dashboard'
import GoogleMapReact from 'google-map-react'
import { toast } from 'react-toastify'
import useSupercluster from 'use-supercluster'
import api from '../../../services/api'
import Vector from '../../../assets/Vector.svg'
import { Image, OverlayTrigger, Tooltip } from 'react-bootstrap'

import styles from './styles.module.css'

import { useAuth } from '../../../hooks/AuthContext'
import { DateTime } from 'luxon'
import { useLoading } from '../../../hooks/LoadingContext'

const Marker = ({ children }) => children

function MainMap() {
  const { authData } = useAuth()
  const navigate = useNavigate()

  const [vehicles, setVehicles] = useState()
  const [position, setPosition] = useState({})
  const [bounds, setBounds] = useState(null)
  const [zoom, setZoom] = useState(10)
  const mapRef = useRef()

  const { setIsLoading } = useLoading()

  useEffect(() => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        setPosition({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        })
      })
    } else {
      setPosition({
        lat: -29.694141,
        lng: -53.747145,
      })
      toast.warning('Ative a localização para facilitar a localização do chamado')
    }
  }, [])

  useEffect(() => {
    async function loadData() {
      try {
        setIsLoading(true)
        const { data } = await api.get('/company/vehicles')
        setVehicles(data)
      } catch (err) {
        //
      }
      setIsLoading(false)
    }
    loadData()
  }, [setIsLoading])

  useEffect(() => {
    async function loadDataTimeout() {
      if (authData.role === 'company') {
        try {
          setIsLoading(true)
          const { data } = await api.get('/company/vehicles')
          setVehicles(data)
        } catch (err) {
          toast.error('Falha ao buscar os dados! Atualize a página.')
        }
        setIsLoading(false)
      }
    }
    let interval = setInterval(() => {
      loadDataTimeout()
    }, 15000)

    return () => {
      clearInterval(interval)
    }
  })

  const points = vehicles
    ? vehicles
        ?.filter((v) => v.lng_current && v.lat_current)
        .map((vehicle) => ({
          type: 'Feature',
          properties: {
            cluster: false,
            userId: vehicle.id,
            board: vehicle.board,
            updated_at: vehicle.updated_at,
          },
          geometry: {
            type: 'Point',
            coordinates: [vehicle.lng_current, vehicle.lat_current],
          },
        }))
    : {
        type: 'Feature',
        properties: { cluster: false, userId: 0 },
        geometry: {
          type: 'Point',
          coordinates: [position.lng, position.lat],
        },
      }

  const { clusters, supercluster } = useSupercluster({
    points,
    bounds,
    zoom,
    options: { radius: 75, maxZoom: 20 },
  })

  /* Date must be a ISO string. Returns a date distance from now. */
  function getDateDistanceFromNow(date) {
    const dateDistance = DateTime.fromISO(date).toRelative({ locale: 'pt-BR' })
    return dateDistance
  }

  return (
    <DashboardLayout backgroundColor="#F8F8F8" pageName="Início" style={{ overflow: 'hidden' }}>
      {Object.keys(position).length ? (
        <div
          style={{
            position: 'absolute',
            inset: '60px 0 0 0',
            overflowY: 'hidden',
            margin: 0,
          }}
        >
          <GoogleMapReact
            bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY }}
            defaultCenter={position}
            defaultZoom={14}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map }) => {
              mapRef.current = map
            }}
            onChange={({ zoom, bounds }) => {
              setZoom(zoom)
              setBounds([bounds.nw.lng, bounds.se.lat, bounds.se.lng, bounds.nw.lat])
            }}
            options={{ fullscreenControl: false }}
          >
            {clusters.map((cluster) => {
              const [longitude, latitude] = cluster.geometry.coordinates
              const { cluster: isCluster, point_count: pointCount } = cluster.properties

              if (isCluster) {
                return (
                  <Marker key={`cluster-${cluster.id}`} lat={latitude} lng={longitude}>
                    <div
                      className={styles.clusterMarker}
                      style={{
                        width: `${10 + (pointCount / points.length) * 20}px`,
                        height: `${10 + (pointCount / points.length) * 20}px`,
                      }}
                      onClick={() => {
                        const expansionZoom = Math.min(
                          supercluster.getClusterExpansionZoom(cluster.id),
                          20,
                        )
                        mapRef.current.setZoom(expansionZoom)
                        mapRef.current.panTo({ lat: latitude, lng: longitude })
                      }}
                    >
                      {pointCount}
                    </div>
                  </Marker>
                )
              }

              return (
                <Marker key={`user-${cluster.properties.userId}`} lat={latitude} lng={longitude}>
                  <OverlayTrigger
                    key={cluster.properties.board}
                    // placement={vehicle.id}
                    overlay={
                      <Tooltip id={`tooltip-${cluster.properties.board}`}>
                        Veículo <strong>{cluster.properties.board}</strong>.
                        <hr />
                        Última atualização {getDateDistanceFromNow(cluster.properties.updated_at)}
                      </Tooltip>
                    }
                  >
                    <Image
                      style={{ cursor: 'pointer', marginLeft: -30, marginTop: -30 }}
                      width={60}
                      src={Vector}
                      onClick={() =>
                        navigate(
                          `/empresa/veiculos/info/${cluster.properties.userId}/entregas-do-dia`,
                        )
                      }
                    />
                  </OverlayTrigger>
                </Marker>
              )
            })}

            {/* {vehicles?.map((vehicle) => (
            <Marker
              lat={vehicle.lat_current}
              lng={vehicle.lng_current}
              vehicle={vehicle}
            ></Marker>
          ))} */}
          </GoogleMapReact>
        </div>
      ) : (
        <div
          style={{
            height: '100vh',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Spinner
            animation="border"
            size="md"
            style={{
              color: '#053C5E',
            }}
          />
        </div>
      )}
    </DashboardLayout>
  )
}

export default MainMap
